import React from 'react';
import { connect } from 'react-redux';
import styles from './NoteContent.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { NoteValidationEngine } from '_helpers';
import { PatientCareCenterNoteHeader } from './Header';
import { PatientCareCenterNoteSubjective } from './Subjective';
import { 
    PatientCareCenterNoteWpSubjective, 
    PatientCareCenterNoteWpObjective, 
    PatientCareCenterNoteWpCharges, 
    PatientCareCenterNoteWpGoals, 
    PatientCareCenterNoteWpAL,
    PatientCareCenterNoteWpPlan,
    PatientCareCenterNoteWpAssessment } from './WorkProgram';
import { PatientCareCenterNoteObjective } from './Objective';
import { PatientCareCenterNoteAL } from './AL';
import { PatientCareCenterNoteGoals } from './Goals';
import { PatientCareCenterNoteAssessment } from './Assessment';
import { PatientCareCenterNotePlan } from './Plan';
import { PatientCareCenterNoteCharges } from './Charges';
import { ScrollDiv, SaveButton } from '_components';

class PatientCareCenterNoteContent extends React.Component {

    saveFinal(checkDate) {
        this.props.saveFinal(this.props.noteId, this.props.epno, checkDate, this.props.trtdate);
        if (this.props.pdfNewWindow && this.props.noteType !== 2 && !this.props.chargeExist) {
            this.downloadPDF();
        }

    }

    render() {
        return (
            <ScrollDiv divId={this.props.noteId} className={styles.wrapper}>
                <PatientCareCenterNoteHeader />
                {!this.props.missedVisits && !this.props.isWp &&
                    <>

                        <PatientCareCenterNoteSubjective refProp={this.props.subjectiveRef} />
                        <PatientCareCenterNoteObjective refProp={this.props.objectiveRef} outcomesRef={this.props.outcomesRef} />
                        <PatientCareCenterNoteAL refProp={this.props.alRef} />
                        <PatientCareCenterNoteGoals refProp={this.props.goalsRef} subjectiveRefProp={this.props.subjectiveRef} />
                        <PatientCareCenterNoteAssessment refProp={this.props.assessmentRef} outcomesRef={this.props.outcomesRef} />
                        <PatientCareCenterNotePlan refProp={this.props.planRef} />
                        <PatientCareCenterNoteCharges refProp={this.props.chargesRef} />
                        <div className={styles.bottom_spacer} />
                    </>
                }

                {this.props.isWp &&
                    <>
                        <PatientCareCenterNoteWpSubjective refProp={this.props.subjectiveRef} />
                        <PatientCareCenterNoteWpObjective refProp={this.props.objectiveRef} outcomesRef={this.props.outcomesRef} />
                        <PatientCareCenterNoteWpAL refProp={this.props.alRef} />
                        <PatientCareCenterNoteWpGoals refProp={this.props.goalsRef} subjectiveRefProp={this.props.subjectiveRef} />
                        <PatientCareCenterNoteWpAssessment refProp={this.props.assessmentRef} outcomesRef={this.props.outcomesRef} />
                        <PatientCareCenterNoteWpPlan refProp={this.props.planRef} />
                        <PatientCareCenterNoteWpCharges refProp={this.props.chargesRef} />
                        <div className={styles.bottom_spacer} />
                    </>
                }

                {this.props.missedVisits && this.props.validated && !this.props.isWp &&
                    <div className={styles.save_final_row}>
                        <SaveButton size='large' title='Save Final' onClick={() => this.saveFinal(false)} />
                    </div>
                }

            </ScrollDiv>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        saveFinal: bindActionCreators(noteActions.saveFinal, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let missedVisits = state.entities.admissions[epno].isPeds && noteType === 22;
    let validated = NoteValidationEngine.getErrors().length === 0 ? true : false;
    let isWp = state.entities.admissions[epno].isWP;
    return {
        validated,
        epno,
        isWp,
        missedVisits,
        noteId: noteId,
        trtdate: state.entities.notes.PTNOTE[pk]?.NTTRTDATE !== undefined ? state.entities.notes.PTNOTE[pk]?.NTTRTDATE : undefined
    };
}

const connectedPatientCareCenterNoteContent = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteContent);
export { connectedPatientCareCenterNoteContent as PatientCareCenterNoteContent };

